import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "freqTable" }
const _hoisted_2 = { class: "usage" }
const _hoisted_3 = { class: "freqTable" }
const _hoisted_4 = ["onClick"]

import { useFrequencyStore } from '../store/frequency'
import { useKeyHandler } from '../utils/useKeyHandler'


export default /*@__PURE__*/_defineComponent({
  __name: 'FreqPage',
  setup(__props) {


const freqStore = useFrequencyStore()

useKeyHandler({
  keyDown (key) {
    switch (key) {
      case 'ArrowLeft':
      case 'KeyQ':
        freqStore.selectLowerBand()
        break

      case 'ArrowRight':
      case 'KeyW':
        freqStore.selectUpperBand()
        break

      case 'KeyR':
        freqStore.selectRandomBand()
        break

      case 'KeyD':
        freqStore.doubleBandCount()
        break

      case 'KeyS':
        freqStore.halveBandCount()
        break

      case 'KeyL':
        freqStore.setLowerFrequencyLimit(freqStore.currentBandIndex)
        break

      case 'KeyH':
        freqStore.setUpperFrequencyLimit(freqStore.currentBandIndex)
        break

      default:
        return
    }

    return false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(freqStore).selectLowerBand && _unref(freqStore).selectLowerBand(...args)))
      }, "Q←: Move 1 band down"),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(freqStore).selectUpperBand && _unref(freqStore).selectUpperBand(...args)))
      }, "→W : Move 1 band up"),
      _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(freqStore).selectRandomBand && _unref(freqStore).selectRandomBand(...args)))
      }, "R : Select random band"),
      _createElementVNode("li", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(freqStore).setLowerFrequencyLimit(_unref(freqStore).currentBandIndex)))
      }, "L: Set lower audible frequency limit"),
      _createElementVNode("li", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(freqStore).setUpperFrequencyLimit(_unref(freqStore).currentBandIndex)))
      }, "H: Set higher audible frequency limit"),
      _createElementVNode("li", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(freqStore).doubleBandCount && _unref(freqStore).doubleBandCount(...args)))
      }, "D : Double band count"),
      _createElementVNode("li", {
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(freqStore).halveBandCount && _unref(freqStore).halveBandCount(...args)))
      }, "S : Halve band count")
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(freqStore).currentBandEqFrequencies, (freq, index) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["cell", {nonAudible: index < _unref(freqStore).currentLowerFreqIndex || index > _unref(freqStore).currentUpperBandIndex, selected: index == _unref(freqStore).currentBandIndex}]),
          key: index,
          onClick: ($event: any) => (_unref(freqStore).currentBandIndex = index)
        }, _toDisplayString(freq.toFixed(0)), 11, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})